const weatherDataReducer = (state = {
  data :null
}, action) => {
    switch (action.type) {
      case 'FETCH_WEATHER_DATA_SUCCESS':{
        let data = null;
        Object.keys(action.payload).map(item => {
          if(action.payload[item]){
            data = action.payload;
          } 
        })
        state = { 
          data : data
        }
    }
  }
    return state;
}

  export default weatherDataReducer;
  